import React, { useEffect } from "react";
import MainLayout from "layouts/MainLayout";
import { Outlet, useLocation } from "react-router";
import { observer } from "mobx-react-lite";
import { buildingStore } from "store/Building/BuildingStore";
import BuildingMenu from "features/Building/BuildingMenu";
import { useBuildings } from "features/Building/useBuildings";
import { useParams } from "react-router-dom";

const Building = observer(() => {
  const location = useLocation();
  const params = useParams();
  const { refreshOnChangeBuilding } = useBuildings();

  useEffect(() => {
    if (!buildingStore.currentBuilding?.id) return;
    onChangeBuilding();
  }, [buildingStore.currentBuilding?.id]);

  async function onChangeBuilding() {
    buildingStore.resetBuildingMappingStatus();
    await refreshOnChangeBuilding();
  }

  useEffect(() => {
    async function pullBuilding() {
      if (params.id !== buildingStore.currentBuilding?.id) {
        const buildingDetails = await buildingStore.getCurrentBuildingDetails(
          params.id
        );
        if (buildingDetails) {
          buildingStore.setCurrentBuilding(buildingDetails);
        }
      }
    }

    pullBuilding();
    callOnRedirect();
  }, [location]);

  async function callOnRedirect() {
    /* to update dashboards and calculations status on changing tabs */
    if (!buildingStore.sourceFiles.loading) {
      await buildingStore.getBuildingMappingStatus();
    }
    await buildingStore.getBuildingCalculationsStatus();
  }

  return location.pathname.includes("mapping-editor") ? (
    <MainLayout noHeader>
      <Outlet />
    </MainLayout>
  ) : (
    <MainLayout>
      <BuildingMenu />
      <Outlet />
    </MainLayout>
  );
});

export default Building;
